/*
 * Vercony soft-conversion events -> GA4 (Route B: events-only gtag in het hoofdvenster).
 * Gereconstrueerd 2026-07-28 (origineel ging verloren met verwijderd thema 201185231196).
 * Config uit window.VerconySC (theme.liquid): { ga4, pageType, templateSuffix }.
 * Consent: geen aparte Shopify-check meer. Events lopen via de gedeelde window.dataLayer,
 *   dus ze erven exact dezelfde Google Consent Mode-status als de store-app (gtag gate't zelf).
 * send_page_view:false (geen dubbele pageviews). Test: voeg ?ga_debug=1 toe voor DebugView.
 * Scoping: pageType 'product' + template.suffix ('partner-page'/'greenup-information'), #MainContent.
 */
(function () {
  'use strict';

  var CFG = window.VerconySC || {};
  var GA4 = CFG.ga4;
  if (!GA4) return;

  var pageType = CFG.pageType || '';
  var suffix   = CFG.templateSuffix || '';
  var DEBUG    = /[?&]ga_debug=1/.test(location.search || '');

  /* ---- events-only gtag (lazy laden bij eerste toegestane event) ---- */
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  var gtagReady = false, gtagLoading = false, gtagQueue = [];
  function ensureGtag() {
    if (gtagReady) return true;
    if (!gtagLoading) {
      gtagLoading = true;
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4);
      s.onload = function () {
        gtag('js', new Date());
        gtag('config', GA4, { send_page_view: false, transport_type: 'beacon' });
        gtagReady = true;
        while (gtagQueue.length) { var q = gtagQueue.shift(); gtag('event', q[0], q[1]); }
      };
      document.head.appendChild(s);
    }
    return false;
  }

  /* ---- consent: geen eigen gate; gtag past Google Consent Mode van de gedeelde
     window.dataLayer toe (identiek aan hoe de store-app trackt) ---- */
  function track(name, params) {
    params = params || {};
    if (DEBUG) params.debug_mode = true;
    if (ensureGtag()) { gtag('event', name, params); }
    else { gtagQueue.push([name, params]); }
  }

  // Expose the tracker so other theme scripts (e.g. the balcony photo-check
  // widget) fire through this same consent-aware, events-only gtag pipeline.
  CFG.track = track;

  var main = document.getElementById('MainContent') || document;
  var once = {};
  function fireOnce(key, name, params) {
    if (once[key]) return;
    once[key] = true;
    track(name, params);
  }

  /* ========== PRODUCTPAGINA ========== */
  if (pageType === 'product') {

    /* pdp_gallery_scrolled — 1x/pagina bij swipe of thumbnail-klik */
    var gallery = main.querySelector('slider-component');
    if (gallery) {
      var fireGallery = function () { fireOnce('gallery', 'pdp_gallery_scrolled', {}); };
      gallery.addEventListener('click', function (e) {
        if (e.target.closest('.thumbnail, [class*="thumbnail"], button, a')) fireGallery();
      });
      gallery.addEventListener('touchstart', fireGallery, { passive: true });
      var trackEl = gallery.querySelector('.slider, [id*="Slider"], ul, [class*="slider"]');
      if (trackEl) trackEl.addEventListener('scroll', fireGallery, { passive: true });
    }

    /* pdp_accordion_opened — 1x/pagina, met section_title. AI-block, fallback <details> */
    function accTitle(el) {
      try {
        var t = el.querySelector('summary, [class*="title"], [class*="header"], button, h2, h3, h4');
        return t ? (t.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100) : '';
      } catch (e) { return ''; }
    }
    var aiRows = main.querySelectorAll('[class*="ai-collapsible-row"]');
    if (aiRows.length) {
      aiRows.forEach(function (row) {
        row.addEventListener('click', function () {
          fireOnce('acc', 'pdp_accordion_opened', { section_title: accTitle(row) });
        });
      });
    } else {
      main.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) fireOnce('acc', 'pdp_accordion_opened', { section_title: accTitle(d) });
        });
      });
    }

    /* pdp_reviews_click — 1x/pagina bij klik in reviews. AI-carousel, fallback kiyoh */
    var reviews = main.querySelector('[class*="ai-review-carousel"]') ||
                  main.querySelector('[class*="kiyoh"], [data-krl]');
    if (reviews) {
      reviews.addEventListener('click', function () {
        fireOnce('rev', 'pdp_reviews_click', {});
      });
    }

    /* balcony_check_opened — 1x/pagina bij openen balkon-pop-up */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-balcony-check-open]')) {
        fireOnce('balc', 'balcony_check_opened', {});
      }
    });
  }

  /* ========== PARTNERPAGINA (template.suffix partner-page) ========== */
  if (suffix === 'partner-page') {
    main.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var external = /^https?:\/\//i.test(href) && a.hostname && a.hostname !== window.location.hostname;
      if (!external) return;
      track('partner_retailer_clickout', {
        link_domain: a.hostname,
        link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100),
        link_url: href
      });
    });
  }

  /* ========== GREENUP-INFO / RELING (template.suffix greenup-information) ========== */
  if (suffix === 'greenup-information') {

    /* greenup_scrolled_bottom — 1x bij ~90% scroll */
    function onScroll() {
      var st = window.pageYOffset || document.documentElement.scrollTop || 0;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && (st / docH) >= 0.9) {
        fireOnce('gscroll', 'greenup_scrolled_bottom', {});
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* greenup_pdp_clickout — elke klik naar /products/ */
    main.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1) return;
      var m = href.match(/\/products\/([^/?#]+)/);
      track('greenup_pdp_clickout', {
        product_handle: m ? m[1] : '',
        link_url: href
      });
    });
  }
})();
